import { Nullable } from '_/types/common.types';
import { IUILoginPool } from '_/types/loginPools';
import { ILogin, ILoginForm, ILoginFormField, ILoginFormParameter, TLoginBody } from '_/types/logins/logins.types';

export const fieldsAdapter = (loginPool: IUILoginPool, login: Nullable<ILogin> = null): ILoginFormField[] =>
  loginPool.fields.map(({ name, secret }) => ({
    name: name || '',
    secret: secret,
    value: (name && login?.fields[name]) || '',
  }));

export const parametersAdapter = (loginPool: IUILoginPool, login: Nullable<ILogin> = null): ILoginFormParameter[] =>
  loginPool.parameters.map(({ name }) => ({
    name: name || '',
    value: (name && login?.parameters[name]) || '',
  }));

export const loginFormAdapter = (loginPool: IUILoginPool, login: ILogin): ILoginForm => ({
  name: login.name,
  active: login.active,
  fields: fieldsAdapter(loginPool, login),
  parameters: parametersAdapter(loginPool, login),
});

export const loginFormToApiAdapter = (loginForm: ILoginForm): TLoginBody => {
  const { name, active, fields, parameters } = loginForm;

  return {
    name: name,
    active: active,
    fields: fields.reduce(
      (obj, field) => {
        if (field.name && field.value.trim() !== '') {
          obj[field.name] = field.value;
        }
        return obj;
      },
      {} as Record<string, string>,
    ),
    parameters: parameters.reduce(
      (obj, param) => {
        if (param.name && param.value.trim() !== '') {
          obj[param.name] = param.value;
        }
        return obj;
      },
      {} as Record<string, string>,
    ),
  };
};
